module.exports = __webpack_public_path__ + "static/mengeMengeMenge-76576efe11b541d2be3be6d70061a74c.png";